/**
 * The dashboard used to be served under /adminDashboard on the old host. It now
 * lives at the domain root, but those URLs are in people's bookmarks, in browser
 * history, and in links that were shared around — and they broke hard rather than
 * politely: index.html referenced its assets relatively, so at /adminDashboard/login
 * the browser asked for /adminDashboard/static/js/main.*.js, the SPA fallback
 * answered with HTML, and the bundle died on "Unexpected token '<'" before a single
 * line of app code ran. A blank page nobody could even sign out of.
 *
 * Absolute asset paths (package.json "homepage": "/") stop the bundle from dying.
 * This strips the dead prefix so the request still lands where it was aiming:
 * /adminDashboard/students keeps its destination instead of dumping the user at home.
 */
const LEGACY_PREFIX = "/adminDashboard";

export function stripLegacyPrefix(pathname) {
  if (typeof pathname !== "string") return "/";
  if (pathname !== LEGACY_PREFIX && !pathname.startsWith(`${LEGACY_PREFIX}/`)) {
    return pathname || "/";
  }
  const rest = pathname.slice(LEGACY_PREFIX.length);
  // "/adminDashboard" and "/adminDashboard/" both mean the dashboard home.
  return rest === "" || rest === "/" ? "/" : rest;
}

export { LEGACY_PREFIX };
